// Codigo de un pedido tal como lo ve el cliente en su ticket: el transaction_code COMPLETO (prefijo de la sucursal +
// contador, ej. "4130682"). Antes el modulo de mesas lo cortaba a los ultimos 6 caracteres ("130682") y no coincidia con
// el ticket. El recorte a 6 solo se conserva para el respaldo cuando no hay transaction_code y se usa el id interno
// (largo) de la orden.
export const formatOrderCode = (order) => {
  const code = order?.transaction_code;
  if (code !== undefined && code !== null && String(code).trim() !== "") return String(code);
  return String(order?.id ?? order?._id ?? "").slice(-6);
};

export default formatOrderCode;
